import { NETWORK_REQUEST_SENT } from './types';
import { BACKEND_URL_PREFIX } from '../utils/const';
import { buildDefaultHeaders } from './helper';
import { checkAndUpdateToken } from './auth';

/* Режим «Факультеты» (Справочники) — шесть методов на чтение.
   Изменяющих методов у режима нет: факультеты, их штат, подчинённые
   подразделения, план переподготовки и имущество заводятся в десктопе.

   Данные режима — экранное состояние одной открытой карточки, в Redux они не
   складываются: сюда вынесен только сам запрос (обновление токена, заголовки,
   разбор конверта ошибки), а результат возвращается вызывающему компоненту. */

/* Адрес собирается при вызове, а не один раз при загрузке модуля.
   utils/const.js импортирует PATHS из Routes.js, Routes.js — сам режим,
   режим — этот файл: на этом круге const.js ещё не доинициализирован, и
   снятый на верхнем уровне BACKEND_URL_PREFIX равен undefined. */
const base = () => `${BACKEND_URL_PREFIX}/faculties`;

const buildQuery = (params) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== '') search.set(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : '';
};

// Конверт ошибки API: { code, detail }. Текст detail пригоден для показа.
const errorOf = async (response) => {
  try {
    const result = await response.json();
    if (result && result.detail) return result.detail;
  } catch (e) {
    /* тело не разобралось — остаётся запасной текст */
  }
  if (response.status === 403) return 'Отсутствуют права доступа';
  if (response.status === 404) return 'Факультет не найден';
  return 'Не удалось получить данные';
};

// Успех — { data }, отказ — { error, status }: код нужен вызывающему,
// чтобы отличить 403 (скрыть вкладку МТС) от прочих ошибок.
const request = (url) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return { error: 'Сессия завершена', status: 401 };

  const response = await fetch(url, buildDefaultHeaders(getState));
  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) return { data: await response.json() };
  return { error: await errorOf(response), status: response.status };
};

// Список. Отбор, поиск, сортировка и постраничная выдача — на сервере.
export const getFaculties = ({ search, status, parentId, sort, order, limit, offset }) =>
  request(`${base()}${buildQuery({
    search,
    status,
    parent_id: parentId,
    sort,
    order,
    limit,
    offset,
  })}`);

export const getFaculty = (id) => request(`${base()}/${id}`);

export const getFacultyDepartments = (id) => request(`${base()}/${id}/departments`);

export const getFacultyPersonnel = (id) => request(`${base()}/${id}/personnel`);

// Без year сервер отдаёт текущий календарный год и перечень доступных лет.
export const getFacultyRetraining = (id, year) =>
  request(`${base()}/${id}/retraining${buildQuery({ year })}`);

export const getFacultyEquipment = (id) => request(`${base()}/${id}/equipment`);
